module.exports = __webpack_public_path__ + "img/Canister.70a3f007.png";